import type { DocSectionContent } from "./content";
import { Markdown } from "./Markdown";

export const DocSection = ({ section }: { section: DocSectionContent }) => (
	<section id={section.id} className="scroll-mt-20 rounded-md border border-line bg-surface">
		<div className="space-y-1 border-b border-line px-5 py-4">
			<h3 className="text-sm font-medium text-ink">{section.title}</h3>
			<p className="text-xs text-ink-muted">{section.summary}</p>
		</div>

		<div className="px-5 py-4">
			<Markdown source={section.body} />
		</div>
	</section>
);
